import { logRocketUtil } from './util/logrocket';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import './assets/i18n/config';
import './index.css';
import reportWebVitals from '@/reportWebVitals';
import { Environments } from '@/util/environments';

if (Environments.isValid(process.env.REACT_APP_ENV)) {
  logRocketUtil.init();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
